import { styled } from '@mui/system'
import Typography from '../../atoms/typography'
import Button from '../../molecules/button'

const Root = styled('div')`
	background-color: ${({ theme }) => theme.palette.grey.lighter};
	padding: 40px ${({ theme }) => theme.spacing(3)};
	margin-top: ${({ theme }) => theme.spacing(4)};
	${({ theme }) => theme.breakpoints.up('sm')} {
		padding: 80px ${({ theme }) => theme.spacing(5)};
		margin-top: ${({ theme }) => theme.spacing(5.75)};
	}
`

const Head = styled('div')`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: ${({ theme }) => theme.spacing(3)};
	flex-wrap: wrap;
	${({ theme }) => theme.breakpoints.up('sm')} {
		flex-wrap: nowrap;
		margin-bottom: ${({ theme }) => theme.spacing(4)};
	}
`

const Title = styled(Typography)`
	margin-bottom: 0;
	font-size: ${({ theme }) => theme.typography.pxToRem(24)};
	width: 100%;
	display: flex;
	align-items: center;
	${({ theme }) => theme.breakpoints.up('sm')} {
		width: auto;
	}
`
const Summary = styled('span')`
	font-size: ${({ theme }) => theme.typography.pxToRem(16)};
	font-family: ${({ theme }) => theme.typography.fontFamily};
	margin-left: ${({ theme }) => theme.spacing(1.2)};
	line-height: ${({ theme }) => theme.typography.pxToRem(18)};
	font-weight: normal;
	margin-top: 4px;
`
const ButtonAddReview = styled(Button)`
	flex: 0 0 auto;
	margin-top: ${({ theme }) => theme.spacing(2)};
	${({ theme }) => theme.breakpoints.up('sm')} {
		margin-top: 0;
	}
`

export { Head, Root, Title, Summary, ButtonAddReview }
